interface DropLineIndicatorProps {
  position: 'top' | 'bottom';
  color: string;
}

function DropLineIndicator({ position, color }: DropLineIndicatorProps) {
  return (
    <div 
      className={`w-full h-0.5 ${position === 'top' ? '-mt-0.5' : '-mb-0.5'}`}
      style={{ 
        backgroundColor: color,
        boxShadow: `0 0 4px ${color}`
      }}
    />
  );
}

export default DropLineIndicator;
